export default __webpack_public_path__ + "static/media/bottom-shape.6b06b0f5.png";